export class SimpleNotification {
  type: SimpleNotificationType;
  message: string;
}

export enum SimpleNotificationType {
  Success,
  Error,
  Info,
  Warning
}



// WEBPACK FOOTER //
// ./src/app/shared/components/simple-notification/models/SimpleNotification.model.ts